// extracted by mini-css-extract-plugin
var _1 = "xsyGS";
var _2 = "RRrDK";
var _3 = "w5teR";
var _4 = "FOLDx";
export { _1 as "create-button", _2 as "filter-block", _3 as "header", _4 as "search-input" }
